import(/* webpackMode: "eager" */ "/codebuild/output/src1948180265/src/client/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1948180265/src/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1948180265/src/client/src/components/global/create-an-account.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1948180265/src/client/src/components/global/newsletter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1948180265/src/client/src/components/global/top-sportsbooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1948180265/src/client/src/components/news/recent-news.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1948180265/src/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1948180265/src/client/src/components/primitives/icon.tsx");
